<div id="o_content" class="o_r_url height-100">
  <div id="error_content" class="error_content">
    <div class="error_content-corps">
      <h2>La page que vous demandez est introuvable.</h2>

      <p>Mais il y a des solutions :</p>
      <ul>
        <li>vérifiez l’adresse de la page</li>
        <li>demander des droits supplémentaires à votre administrateur si vous pensez que cette page existe</li>
      </ul>
      <p></p>

      <p>Vous avez aussi la possibilité de retourner en <a routerLink="/">page d’accueil</a>.</p>
    </div>
  </div>
</div>
